export default __webpack_public_path__ + "static/media/ghost.23f2f672.png";